// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".style_root__2t8DK {\n  margin-top: 20px;\n  margin-bottom: 8px;\n  display: grid;\n  align-items: center;\n  grid-template-columns: 286px 2fr 90px 90px 100px 150px;\n  width: calc(100% - 10px); }\n  .style_root__2t8DK .style_item__8R6W0 {\n    -webkit-user-select: none;\n            user-select: none;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    color: #464646;\n    cursor: pointer; }\n", ""]);
// Exports
exports.locals = {
	"root": "style_root__2t8DK",
	"item": "style_item__8R6W0"
};
module.exports = exports;
